import { MaxTurnState } from '../../types'

/**
 * - `visible`: the turn belongs to the conversation on screen.
 * - `background`: same tenant, another conversation.
 * - `foreign`: the turn was sent under another tenant.
 * - `unknown`: the frame cannot be attributed to a registered turn.
 */
export type FrameScope = 'visible' | 'background' | 'foreign' | 'unknown'

export interface RealtimeFrameScopeContext {
  selectedTenantId: string | null | undefined
  visibleConversationId: string | null | undefined
  activeTempConversationId: string | null | undefined
}

export interface RealtimeFrameIdentity {
  clientRequestId?: string | null
  tenantId?: string | null
}

export function resolveFrameScope(
  frame: RealtimeFrameIdentity | null | undefined,
  turn: MaxTurnState | null | undefined,
  context: RealtimeFrameScopeContext
): FrameScope {
  const clientRequestId = frame?.clientRequestId
  if (!clientRequestId || !turn) return 'unknown'

  if (frame?.tenantId && frame.tenantId !== turn.tenantId) {
    return 'unknown'
  }

  if (!context.selectedTenantId || turn.tenantId !== context.selectedTenantId) {
    return 'foreign'
  }

  if (turn.conversationId && turn.conversationId === context.visibleConversationId) {
    return 'visible'
  }

  if (
    !context.visibleConversationId &&
    turn.tempConversationId &&
    turn.tempConversationId === context.activeTempConversationId
  ) {
    return 'visible'
  }

  return 'background'
}
